import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';

export const SET_DESKTOP_VIEW_SELECTED = 'SET_DESKTOP_VIEW_SELECTED';
export const SET_FULLSCREEN = 'SET_FULLSCREEN';
export const SET_SELECTED_DEVICE_TYPE = 'SET_SELECTED_DEVICE_TYPE';

export interface ISetDesktopViewSelectedAction {
    type: typeof SET_DESKTOP_VIEW_SELECTED;
    payload: boolean;
}

export interface ISetFullScreenAction {
    type: typeof SET_FULLSCREEN;
    payload: boolean;
}

export interface ISetSelectedDeviceTypeAction {
    type: typeof SET_SELECTED_DEVICE_TYPE;
    payload: DeviceType;
}

export type LayoutReducerType = ISetDesktopViewSelectedAction | ISetFullScreenAction | ISetSelectedDeviceTypeAction;
